"use client";

// packages/eden-icons/src/generated-from-source/InfoFilled.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var InfoFilled = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm.1-16.55c.752 0 1.336.547 1.336 1.282 0 .728-.585 1.273-1.336 1.273-.75 0-1.336-.545-1.336-1.273 0-.735.584-1.282 1.336-1.282zM11.014 9.5v8.884h2.172V9.5h-2.172z", fillRule: "evenodd", clipRule: "evenodd", children: " " })
] });
var InfoFilled_default = InfoFilled;
export {
  InfoFilled_default as default
};
